import { mdiClose, mdiHome, mdiEyeOff, mdiEye } from '@mdi/js';

export const icons = {
  close: mdiClose,
  home: mdiHome,
  eyeOff: mdiEyeOff,
  eye: mdiEye
};
